import apiRequest from '@app/utils/apiRequest';

export const requestCandidateGroups = (params) => apiRequest.get(`/candidate/candidate-group/list`, {params: params});

export const requestSaveCandidateGroup = (data) =>
    apiRequest.post(`/candidate/candidate-group/save`, data);

export const requestDeleteGroup = (data) =>
    apiRequest.delete(`/candidate/candidate-group/delete`, {data: data});

export const requestRemoveCandidateOutGroup = (data) =>
    apiRequest.post(`/candidate/candidate-group/remove-candidate`, data);

export const requestAddCandidateIntoGroup = (data) =>
    apiRequest.post(`/candidate/candidate-group/add-candidate`, data);
